import { render, staticRenderFns } from "./RecentlyCompletedTestsMenuPreview.vue?vue&type=template&id=d4c06396"
import script from "./RecentlyCompletedTestsMenuPreview.vue?vue&type=script&lang=js"
export * from "./RecentlyCompletedTestsMenuPreview.vue?vue&type=script&lang=js"
import style0 from "./RecentlyCompletedTestsMenuPreview.vue?vue&type=style&index=0&id=d4c06396&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports